import { render } from "./SuperOrganizationDetails.vue?vue&type=template&id=71706a98&scoped=true&ts=true"
import script from "./SuperOrganizationDetails.vue?vue&type=script&lang=ts"
export * from "./SuperOrganizationDetails.vue?vue&type=script&lang=ts"

import "./SuperOrganizationDetails.vue?vue&type=style&index=0&id=71706a98&scoped=true&lang=css"
import "./SuperOrganizationDetails.vue?vue&type=style&index=1&id=71706a98&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71706a98"]])

export default __exports__